import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var Chart;
declare var $;

@Component({
  selector: 'app-chart-line',
  templateUrl: './chart-line.component.html',
  styleUrls: ['./chart-line.component.scss']
})
export class ChartLineComponent implements OnInit {

  @Input() public element: string;
  @Input() public heightSize: string;
  @Input() public firstData: any;
  @Input() public secondData: any;
  @Input() public firstDataLabel: any;
  @Input() public secondDataLabel: any;
  @Input() public graficData: any;
  @Input() public min: any = 0;
  @Input() public max: any = 10;
  @Input() public steps: any = 10;
  @Input() public printing: boolean = false;
  @Output() public chartReady: EventEmitter<void> = new EventEmitter<void>();
datos:any;

  public myChart;
  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.startChart();
    }, 200);
  }

  startChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }
    this.myChart = new Chart(this.ctx(), {
        type: 'line',
        data: this.data(),
        options: this.options()
    });
    this.chartReady.emit();
  }

  resizeChart() {
    if (this.myChart) {
      this.myChart.resize();
    }
  }


  data() {
    return {
      labels: this.graficData,
      //labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      datasets: [{
          label: this.firstDataLabel,
          backgroundColor: 'rgba(114, 124, 245, 0.3)',
          borderColor: '#727cf5',
          data: this.firstData
          //data: ["500.00", "42", "42", "62", "52", "75", "62"]
      }, {
          label: this.secondDataLabel,
          fill: true,
          backgroundColor: 'transparent',
          borderColor: "#0acf97", 
          borderDash: [5, 5],
          data: this.secondData
          //data: [42, 58, 66, 93, 82, 105, 92]
      }]
    };
  }

  options() {
    return {
      maintainAspectRatio: false,
      legend: {
          display: false
      },
      tooltips: {
          intersect: false
      },
      hover: {
          intersect: true
      },
      plugins: {
          filler: {
              propagate: false
          }
      },
      scales: {
          xAxes: [{
              reverse: true,
              gridLines: {
                  color: "rgba(0,0,0,0.05)"
              }
          }],
          yAxes: [{
              ticks: {
                  stepSize: this.getStepSize()
              },
              display: true,
              borderDash: [5, 5],
              gridLines: {
                  color: "rgba(0,0,0,0)",
                  fontColor: '#fff'
              }/* funcion para modificar las etiquetas de y
              afterTickToLabelConversion : function(q){
                for(var tick in q.ticks){
                    console.log('q.ticks[tick] ', q.ticks[tick]);
                    q.ticks[tick] += '\u00B0C';
                }
              }*/
          }]
      }
    };
  }

  ctx() {
    return this.input().get(0).getContext('2d');
  }

  input() {
      return $('#' + this.element);
  }

  getStepSize() {
    if (this.max == this.min) {
      return this.min;
    }
    return (this.max - this.min) / this.steps;
  }

  setChartDraw() {
    var draw3 = Chart.controllers.bar.prototype.draw;
        Chart.controllers.bar = Chart.controllers.bar.extend({
            draw: function () {
                draw3.apply(this, arguments);
                var ctx = this.chart.chart.ctx;
                var _fill = ctx.fill;
                ctx.fill = function () {
                    ctx.save();
                    ctx.shadowColor = 'rgba(0,0,0,0.01)';
                    ctx.shadowBlur = 20;
                    ctx.shadowOffsetX = 4;
                    ctx.shadowOffsetY = 5;
                    _fill.apply(this, arguments)
                    ctx.restore();
                }
            }
        });
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      if (changes.printing && !changes.printing.firstChange) {
        this.resizeChart();
      } else {
        this.startChart();
      }
    }, 200);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/charts/chart-line/chart-line.component.ts